
<div class="footer bg-white py-4 d-flex flex-lg-column mt4">
    <!--begin::Container-->
    <div class="container-fluid d-flex flex-column flex-md-row align-items-center justify-content-between">
        <!--begin::Copyright-->
        <div class="text-dark order-2 order-md-1">
            <span class="text-dark-75 text-hover-primary">MSIS ©{{currentYear}} v{{version}}</span>
        </div>
        <!--end::Copyright-->
    </div>
    <!--end::Container-->
</div>
